import {
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_MAP,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_FLOW,
  RESOURCE_TYPE_RECORD_TRANSFORM,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';
import { SearchFilterViews, SearchFilterViewsType } from 'js/constants/visibilityFilters';
import {
  getEligibleCredentialEntities,
  getEligibleDataMapEntities,
  getEligibleSinkEntities,
  getEligibleSourceEntities,
  getMyDataSetEntities,
} from 'js/reducers/selectors';
import {
  dataCardListLoadPipelines,
  loadDataCredentialListing,
  loadDataMapListing,
  loadDataFeedDataSets,
  loadDataSources,
  loadMyDataSinks,
} from 'js/actions';
import { getSearchFlows } from 'js/reducers/entities/selectors';

export const resourceNames = {
  [RESOURCE_TYPE_SINK]: 'Destination',
  [RESOURCE_TYPE_DATA_MAP]: 'Lookup',
  [RESOURCE_TYPE_CREDENTIALS]: 'Credential',
  [RESOURCE_TYPE_SOURCE]: 'Source',
  [RESOURCE_TYPE_DATA_SET]: 'Nexset',
  [RESOURCE_TYPE_FLOW]: 'Flow',
  [RESOURCE_TYPE_RECORD_TRANSFORM]: 'Code Container',
};

export const entityNameByType = {
  [RESOURCE_TYPE_FLOW]: 'flowNodes',
  [RESOURCE_TYPE_SINK]: 'sinks',
  [RESOURCE_TYPE_DATA_MAP]: 'dataMaps',
  [RESOURCE_TYPE_CREDENTIALS]: 'credentials',
  [RESOURCE_TYPE_SOURCE]: 'sources',
  [RESOURCE_TYPE_DATA_SET]: 'dataSets',
  [RESOURCE_TYPE_RECORD_TRANSFORM]: 'transforms',
};

export const selectorsByType = {
  [RESOURCE_TYPE_SINK]: getEligibleSinkEntities,
  [RESOURCE_TYPE_DATA_MAP]: getEligibleDataMapEntities,
  [RESOURCE_TYPE_CREDENTIALS]: getEligibleCredentialEntities,
  [RESOURCE_TYPE_SOURCE]: getEligibleSourceEntities,
  [RESOURCE_TYPE_FLOW]: getSearchFlows,
  [RESOURCE_TYPE_DATA_SET]: getMyDataSetEntities,
};

export const loadByType = {
  [RESOURCE_TYPE_FLOW]: dataCardListLoadPipelines,
  [RESOURCE_TYPE_SINK]: loadMyDataSinks,
  [RESOURCE_TYPE_DATA_MAP]: loadDataMapListing,
  [RESOURCE_TYPE_CREDENTIALS]: loadDataCredentialListing,
  [RESOURCE_TYPE_SOURCE]: loadDataSources,
  [RESOURCE_TYPE_DATA_SET]: loadDataFeedDataSets,
};

export const resourceSearchView = {
  [RESOURCE_TYPE_FLOW]: SearchFilterViews.SEARCH_PIPELINES,
  [RESOURCE_TYPE_SINK]: SearchFilterViews.DATA_SINKS,
  [RESOURCE_TYPE_DATA_MAP]: SearchFilterViews.DATA_MAPS,
  [RESOURCE_TYPE_CREDENTIALS]: SearchFilterViews.CREDENTIALS,
  [RESOURCE_TYPE_SOURCE]: SearchFilterViews.SOURCES,
  [RESOURCE_TYPE_DATA_SET]: SearchFilterViews.MY_DATA_SETS,
  [RESOURCE_TYPE_RECORD_TRANSFORM]: SearchFilterViews.REUSABLE_TRANSFORMS,
} as unknown as SearchFilterViewsType;
